<script setup>
import Close from '@/assets/images_manse/icon_close_2.svg';

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  maxLength: {
    type: Number,
    default: 20,
  },
  dataType: {
    type: String,
    default: '',
  },
  type: {
    type: String,
    default: 'text',
  },
  placeholder: {
    type: String,
    default: '',
  },
  validationMessage: {
    type: String,
    default: '',
  },
  clearable: {
    type: Boolean,
    default: false,
  },
  inputHandler: {
    type: Function,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: null,
  },
  inputmode: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['update:modelValue', 'blur']);

const inputValue = ref(props.modelValue);

watch(
  () => props.modelValue,
  (newValue) => {
    inputValue.value = newValue;
  },
);

const handleInput = (event) => {
  let value = event.target.value;
  const dataType = props.dataType;
  if (props.inputHandler) value = props.inputHandler({ value, dataType });

  inputValue.value = value;
  emit('update:modelValue', value);
};

const clearInput = () => {
  let value = '';
  const dataType = props.dataType;
  if (props.inputHandler) value = props.inputHandler({ value, dataType });

  inputValue.value = value;
  emit('update:modelValue', '');
};

const handleBlur = () => {
  emit('blur');
};
</script>

<template>
  <div class="custom-input">
    <div class="custom-input-container">
      <div class="custom-input-wrapper">
        <input
          v-model="inputValue"
          :maxlength="maxLength"
          :type="type"
          :inputmode="inputmode"
          :placeholder="placeholder"
          :class="['custom-input-box', { invalid: validationMessage, disabled: disabled }]"
          :disabled="disabled"
          @input="handleInput"
          @blur="handleBlur"
        />

        <div class="add-on">
          <span v-if="clearable && inputValue" class="clear-btn" @click="clearInput">
            <component :is="Close" />
          </span>

          <slot name="inner"></slot>
        </div>
      </div>

      <slot name="outer"></slot>
    </div>

    <div v-if="validationMessage" class="validation-message">
      {{ validationMessage }}
    </div>
  </div>
</template>
